import React from 'react';
import { Clock } from 'lucide-react';

interface PomodoroSettingsProps {
  pomodoroDefaultMinutes: number;
  setPomodoroDefaultMinutes: React.Dispatch<React.SetStateAction<number>>;
  isLoading: boolean;
}

export const PomodoroSettings: React.FC<PomodoroSettingsProps> = ({
  pomodoroDefaultMinutes,
  setPomodoroDefaultMinutes,
  isLoading,
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        <Clock className="w-4 h-4 inline mr-2" />
        Pomodoro Timer Default Duration (Personal)
      </label>
      <div className="flex items-center space-x-3">
        <input
          type="number"
          min="1"
          max="99"
          value={pomodoroDefaultMinutes}
          onChange={(e) => setPomodoroDefaultMinutes(Math.max(1, Math.min(99, parseInt(e.target.value) || 25)))}
          className="w-20 px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center"
          disabled={isLoading}
        />
        <span className="text-sm text-gray-600 dark:text-gray-400">minutes</span>
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
        Set your preferred default duration for the Pomodoro timer when working on personal tasks (not in a team context).
      </p>
    </div>
  );
};